<!-- User profile -->
<li class="nav-item d-inline-block" ngbDropdown placement="bottom-right" display="dynamic">
  <a class="nav-link position-relative" id="dropdownBasic3" ngbDropdownToggle>
    <i [ngClass]="userIconClass"></i>
    <span class="text-bold-400 text-dark text-uppercase"> {{ userName }}</span>
  </a>
  <div ngbDropdownMenu aria-labelledby="dropdownBasic3">

    <!-- Change Password -->
    <a class="dropdown-item" routerLink="/account/change-password">
      <i class="ft-lock mr-2"></i>
      <span>{{ 'userProfile.changePasswordTitle' | translate }}</span>
    </a>

    <!-- Two Factor Setup -->
    <a class="dropdown-item" routerLink="/account/two-factor-setup">
      <i class="icon-key mr-2"></i>
      <span>{{ 'userProfile.twoFactorSetupTitle' | translate }}</span>
    </a>

    <!--  Logout -->
    <a class="dropdown-item" (click)="authenticationService.logout()">
      <i class="ft-power mr-2"></i>
      <span>{{ 'userProfile.logoutTitle' | translate }}</span>
    </a>
  </div>
</li>
